<template>
  <div class="step-icon">
    <img
      class="step-icon__img"
      :src="imgSrc"
    >

    <div class="step-icon__slot">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  // Name
  name: 'step-icon',

  // Props
  props: {
    imgSrc: {
      type: String,
      default: undefined
    }
  }
}
</script>

<style scoped lang="scss">
.step-icon {
  margin-bottom: 30px;

  &__img {
    display: block;
    width: 160px;
    height: 160px;
    margin: 20px auto 10px auto;

    @include breakpoint('tablet-portrait-up') {
      width: 200px;
      height: 200px;
    }
  }

  &__slot {
    text-align: center;
    font-size: 14px;
    line-height: 19px;

    @include breakpoint('tablet-portrait-up') {
      font-size: 20px;
      line-height: 27px;
    }
  }
}
</style>
